//import $ from 'jquery';
import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer,SuperClusterAlgorithm,DefaultRenderer } from "@googlemaps/markerclusterer";
import { tns } from 'tiny-slider/src/tiny-slider';
import 'geojson-bounds';

let map;
let bounds = null;
let clusters = null;
let $dataPanel = null;
const mapElement = document.getElementsByClassName('carte-layout__map');
const searchInput = document.getElementsByClassName('js-map-search');
const categSelects = document.getElementsByClassName('js-choose-categ');
const mapVenueCards = document.getElementsByClassName('map-venue-card');
const sidePanelOfCategs = document.getElementsByClassName('side-panel__categories');
const noResultsText = document.getElementsByClassName('side-panel__no-results');
const boundsboxArray = boundsbox.split(',');
const $side_panel = document.querySelector('.side-panel');

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

let markerMode = 'basic';
let infowindow = null;
let infowindowTimeout = null;

let highlightZone = null;

if(mapElement){
    Array.prototype.forEach.call(mapElement, creationGMapElement)
}

function creationGMapElement(el){
    if(!document.getElementsByTagName('body')[0].getAttribute('data-additionnal-categ')){
        document.getElementsByTagName('body')[0].setAttribute('data-additionnal-categ','');
    }
    const lat = 46;
    const lng = -73;
    const lang = el.getAttribute('data-lang');
    const key = el.getAttribute('data-key');
    let loader;
    try {
        loader = new Loader({
            apiKey:key,
            version:'weekly',
            language: lang.substring(0,2),
            //version:'beta',
            //libraries: ["marker"]
        });
    } catch (error) {
        location.reload();
    }
    loader.load().then(()=>{
        var reclat = 0.0004;
        var reclng = 0.000;
        map = new google.maps.Map(document.getElementById(el.getAttribute('id')), {
            center: {lat: lat+reclat, lng: lng+reclng},
            zoom: 10,
            language: lang,
            streetViewControl:false,
            mapTypeControl: mapTypeControl,
            gestureHandling: "greedy",
            styles: actMapStyles
        });
        map.addListener('mapcapabilities_changed', () => {
            const mapCapabilities = map.getMapCapabilities();

            if (!mapCapabilities.isAdvancedMarkersAvailable) {
                markerMode = 'basic';
            } else {
                markerMode = 'advanced';
            }
          });

        infowindow = new google.maps.InfoWindow({
            content: '',
        });

        google.maps.event.addListener(infowindow, 'domready', function() {
            document.querySelector('.infowindow').addEventListener('mouseover', function(e) {
                if (!e.currentTarget.classList.contains('infowindow--active')) {
                    clearTimeout(infowindowTimeout);
                }
            });
            document.querySelector('.infowindow').addEventListener('mouseout', function(e) {
                if (!e.currentTarget.classList.contains('infowindow--active')) {
                    infowindowTimeout = setTimeout(closeInfoWindow, 250);
                }
            });
            document.querySelector('.infowindow .js-close-data-panel').addEventListener('click',closePin);
        });

        redoMarkers();

        //TODO: Trouver meilleure facon que timeout
        window.setTimeout(function(){
            let initForceCenterArray = initForceCenter.split(',');
            if(initForceCenterArray.length == 2){
                map.setCenter({
                    lat:parseFloat(initForceCenterArray[0]),
                    lng:parseFloat(initForceCenterArray[1])
                });
            }
            if(initForceZoom != ''){
                //console.log(parseInt(initForceZoom));
                map.setZoom(parseInt(initForceZoom));
            }
        },300)
    })
}

function closeInfoWindow(preventCloseActive) {
    // console.log('Check closeInfoWindow()');

    if (preventCloseActive && infowindow.getContent().indexOf("infowindow--active") > 0) {
        return;
    }
    // console.log('inside closeInfoWindow()');
    infowindow.setContent(infowindow.getContent().replace("infowindow--active", ""));
    infowindow.setContent(infowindow.getContent().replace("infowindow", ""));
    infowindow.close();
    // console.log('fin de closeInfoWindow()');
}

/*
if(categSelects){
    Array.prototype.forEach.call(categSelects,function(el){
        el.addEventListener('change',function(){
            console.log('redraw - categs');
            redoMarkers();
        })
    })
}
// Le On marche pas, https://github.com/sa-si-dev/virtual-select/issues/194 Passé aux développeurs du truc
// C'est une fonctionalité écrite dans leur doc, alors j'imagine c'est juste un glitch, qui sera réglé.
// Désolé du funk en dessous, mais c'est fait que on puisse continuer a travailler, et on mettera le onchange quand sa sera réglé.
// https://sa-si-dev.github.io/virtual-select/#/events
*/
setInterval(triggerCheckRedoMarkersByCategorySelect,100)
function triggerCheckRedoMarkersByCategorySelect(){
    var triggerRewrite = false;
    if(categSelects){
        Array.prototype.forEach.call(categSelects,function(el){
            //console.log(String(el.value))
            if(!el.hasAttribute('currentValue') && el.value){
                el.setAttribute('currentValue',el.value);
            }else if(el.getAttribute('currentValue') != String(el.value)){
                el.setAttribute('currentValue',el.value);
                triggerRewrite = true;
            }
        })
    }
    if(triggerRewrite){
        redoMarkers();
    }
}
setInterval(keepPinsTabbable,500)
function keepPinsTabbable(){
    const pins = document.querySelectorAll('.carte-layout__map [role="button"]')
    if(pins.length != 0){
        pins.forEach(function(e){
            e.setAttribute('tabindex',0);
        })
    }
}

if(searchInput[0]){
    //console.log(searchInput);
    searchInput[0].addEventListener('keyup',triggerRedoMarkersByTextSearch)
    searchInput[0].addEventListener('keydown',function(event){
        if(event.keyCode == 13) {
            //prevent submit via entrée
            event.preventDefault();
            return false;
        }
    })
}
var timeout;
function triggerRedoMarkersByTextSearch(){
    // console.log('search');
    if(searchInput[0]){
        // console.log(searchInput[0].value);
        if(searchInput[0].value){
            if(sidePanelOfCategs[0]){
                sidePanelOfCategs[0].classList.add('is-fully-open');
            }
            let dupesArray = Array();
            Array.prototype.forEach.call(mapVenueCards,function(e){
                if(dupesArray.includes(e.getAttribute('data-id'))){
                    //e.classList.add('map-venue-card__hidden');
                    e.classList.add('map-venue-card__is-dupe');
                }else{
                    dupesArray.push(e.getAttribute('data-id'));
                }
            })
        }else{
            if(sidePanelOfCategs[0]){
                Array.prototype.forEach.call(mapVenueCards,function(e){
                    e.classList.remove('map-venue-card__is-dupe');
                })
                sidePanelOfCategs[0].classList.remove('is-fully-open');
            }
        }
    }
    clearTimeout(timeout);
    //console.log('search');
    if(searchInput[0]){
        if(searchInput[0].value){
            $side_panel.classList.add('side-panel--fully-opened');
            searchInput[0].parentElement.classList.add('map-text-search__has-data');
        }else{
            searchInput[0].parentElement.classList.remove('map-text-search__has-data');
            if(!document.querySelectorAll('.side-panel__toggle-results--active').length) {
                $side_panel.classList.remove('side-panel--fully-opened');
            }
        }
    }
    timeout = setTimeout(redoMarkers, 500);
}

const ClusterRenderer = function() {
    const svg = window.btoa(clusterSVG);
    return {
        render: ({ count, position }) => {
           return new google.maps.Marker({
            position,
               title: String(count)+' '+clusterText,
                label: {
                    text: String(count),
                    color: clusterNumberColor,
                    fontSize: clusterNumberFontSize,
                    fontWeight: clusterNumberFontWeight,
                    fontFamily: clusterNumberFontFamily
                },
                icon: {
                    url: `data:image/svg+xml;base64,${svg}`,
                    scaledSize: new google.maps.Size(parseInt(clusterSize), parseInt(clusterSize))
                },
                // adjust zIndex to be above other markers
                zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
            })
        }
    }
}
/*
function buildMarkerMarkup(data)
{
    const content = document.createElement("div");

  content.classList.add("pin");
  content.innerHTML = `
    <div class="icon">
        <?xml version="1.0" encoding="UTF-8"?>
        <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="512" height="512"><path d="M19,1H5A5.006,5.006,0,0,0,0,6V18a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V6A5.006,5.006,0,0,0,19,1ZM5,3H19a3,3,0,0,1,2.78,1.887l-7.658,7.659a3.007,3.007,0,0,1-4.244,0L2.22,4.887A3,3,0,0,1,5,3ZM19,21H5a3,3,0,0,1-3-3V7.5L8.464,13.96a5.007,5.007,0,0,0,7.072,0L22,7.5V18A3,3,0,0,1,19,21Z"/></svg>
    </div>
    `;
    //TODO addinfowindow
  return content;

}
*/
function adjustMarkerVisibility()
{
    closeInfoWindow(true);
    if(actMapData.length){
        actMapData.forEach(function(e){
            let forceShow = false;
            let el = document.getElementById('venue-card-'+e.id);
            if(el && el.classList.contains('map-venue-card__is-active')){
                forceShow = true;
            }
            if(e.marker){
                if (e.marker.getMap() || forceShow) {
                    if (!e.htmlMarker.getMap()) {
                        e.htmlMarker.setMap(map);
                    }
                } else {
                    if (e.htmlMarker.getMap()) {
                        e.htmlMarker.setMap(null);
                    }
                }
            }
        });
    }

}

function generateInfoWindowContent(e) {
    let htmlContent = '';
    if (infoWindowCallback !== '') {
        htmlContent = window[infoWindowCallback].call(this, e);
    } else {
        const categArray = e.categ ? e.categ.split('|') : [];
        let categString = '';
        Array.prototype.forEach.call(categArray,function(c){
            //console.log(c);
            if(c != ''){
                if(c.includes('~')){
                    c = c.split('~')
                    categString += '<div class="map-badge" style="background:'+c[0]+'">'+c[1]+'</div>';
                }else{
                    categString += '<div class="map-badge">'+c+'</div>';
                }
            }
        });
        let title = '';
        if (e.rue_travaux) {
            title = '<div class="infowindow__rue-travaux"><strong>' + e.rue_travaux + '</strong></div>';
        } else {
            title = e.title;
        }
        let extraInfos = '';
        if (e.rue) {
            extraInfos += '<div class="infowindow__rue"><strong>Rue:</strong> ' + e.rue + '</div>';
        }
        if (e.date) {
            extraInfos += '<div class="infowindow__date"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.8327 3.33317H14.166V2.49984C14.166 2.0396 13.7929 1.6665 13.3327 1.6665C12.8724 1.6665 12.4993 2.0396 12.4993 2.49984V3.33317H7.49935V2.49984C7.49935 2.0396 7.12625 1.6665 6.66602 1.6665C6.20578 1.6665 5.83268 2.0396 5.83268 2.49984V3.33317H4.16602C2.7853 3.33317 1.66602 4.45246 1.66602 5.83317V15.8332C1.66602 17.2139 2.7853 18.3332 4.16602 18.3332H15.8327C17.2134 18.3332 18.3327 17.2139 18.3327 15.8332V5.83317C18.3327 4.45246 17.2134 3.33317 15.8327 3.33317ZM16.666 15.8333C16.666 16.2935 16.2929 16.6666 15.8327 16.6666H4.16603C3.70579 16.6666 3.33269 16.2935 3.33269 15.8333V9.99994H16.666V15.8333ZM16.666 8.33327H3.33269V5.83327C3.33269 5.37304 3.70579 4.99994 4.16603 4.99994H5.83269V5.83327C5.83269 6.29351 6.20579 6.66661 6.66603 6.66661C7.12627 6.66661 7.49936 6.29351 7.49936 5.83327V4.99994H12.4994V5.83327C12.4994 6.29351 12.8725 6.66661 13.3327 6.66661C13.7929 6.66661 14.166 6.29351 14.166 5.83327V4.99994H15.8327C16.2929 4.99994 16.666 5.37304 16.666 5.83327V8.33327Z" fill="#0064BD"/></svg><strong>Date:</strong> ' + e.date + '</div>';
        }
        if (e.plan_de_detour) {
            extraInfos += '<div class="infowindow__plan-detour"><a href="' + e.plan_de_detour + '" target="_blank"><strong>Plan de détour</strong></a></div>';
        }
        
        htmlContent = '<div class="infowindow__categ map-badges">'+categString+'</div><div class="infowindow__title">'+title+'</div>' + extraInfos;
    }

    const closeButton = document.querySelector('.js-close-data-panel').cloneNode(true);
    var wrap = document.createElement('div');
    wrap.appendChild(closeButton);
    closeButton.classList.add('infowindow__close');
    closeButton.classList.add('icon-button--small');
    const infowindowContent = '<div class="infowindow">'+wrap.innerHTML+htmlContent+'</div>'
    return infowindowContent;
}

function setIconInHtmlMarker(icon, htmlMarker) {
    htmlMarker.icon = icon;
    if (htmlMarker.div) {
        htmlMarker.div.innerHTML = pinSVG+(icon ? icon : '');
        htmlMarker.div.childNodes[0].classList.add('carte-pin__marker');
        const paths = htmlMarker.div.childNodes[0].getElementsByTagName('path');
        for (var i = 0; i < paths.length; i++) {
            paths[i].style.fill = htmlMarker.color;
        }
        if (htmlMarker.div.childNodes.length > 1) {
            htmlMarker.div.childNodes.item(1).classList.add('carte-pin__icon');
        }
    }
}


function redoMarkers(closePins = true){
    if(closePins){
        closeInfoWindow();
        closePin();
    }
    class HtmlMarker extends google.maps.OverlayView {
        position;
        icon;
        color;
        title;
        div;
        constructor(position, icon, title, color) {
          super();
          this.position = position;
          this.icon = icon;
          this.title = title;
          this.color = color;
        }
        /**
         * onAdd is called when the map's panes are ready and the overlay has been
         * added to the map.
         */
        onAdd() {
            const panes = this.getPanes();
            this.div = document.createElement("div");
            this.div.style.borderStyle = "none";
            this.div.style.borderWidth = "0px";
            this.div.style.position = "absolute";
            this.div.classList.add('carte-pin');
            setIconInHtmlMarker(this.icon, this);
            panes.overlayLayer.appendChild(this.div)
        }
        draw() {
            const projection = this.getProjection()
            const point = projection.fromLatLngToDivPixel(this.position)
            if (point === null) {
              return
            }
            this.div.style.transform = `translate(${point.x}px, ${point.y}px)`
        }
        /**
         * The onRemove() method will be called automatically from the API if
         * we ever set the overlay's map property to 'null'.
         */
        onRemove() {
          if (this.div) {
            this.div.parentNode.removeChild(this.div);
            delete this.div;
          }
        }
        /**
         *  Set the visibility to 'hidden' or 'visible'.
         */
        hide() {
          if (this.div) {
            this.div.style.visibility = "hidden";
          }
        }
        show() {
          if (this.div) {
            this.div.style.visibility = "visible";
          }
        }
        toggle() {
          if (this.div) {
            if (this.div.style.visibility === "hidden") {
              this.show();
            } else {
              this.hide();
            }
          }
        }
        toggleDOM(map) {
          if (this.getMap()) {
            this.setMap(null);
          } else {
            this.setMap(map);
          }
        }
      }

    //console.log('redraw');
    let fitBounds = false;
    bounds = new google.maps.LatLngBounds();

    if (!clusters) {
        clusters = new MarkerClusterer({
            map:map,
            renderer:new ClusterRenderer,
            algorithm: new SuperClusterAlgorithm({
                radius:clusterRadius
            }),
            onClusterClick: (
                _,
                cluster,
                map
              ) => {
                  closePin(false);
                  map.fitBounds(cluster.bounds,32);
              }
        });

        google.maps.event.addListener(
            clusters,
            'clusteringend',
            adjustMarkerVisibility
          );
    }
    //True est important pour ne pas reconstruire la carte tout de suite, on fait render plus bas
    clusters.clearMarkers(true);
    //console.log(bounds);
    let currentOpenPin = null;
    if(mapElement[0].getAttribute('data-open-pin')){
        if(actMapData.length){
            actMapData.forEach(function(e){
                if(mapElement[0].getAttribute('data-open-pin') == e.id){
                    currentOpenPin = e;
                }
            })
        }
    }
    //console.log(currentOpenPin);
    if(actMapData.length){
        const additionnalCateg  = document.getElementsByTagName('body')[0].getAttribute('data-additionnal-categ') ? document.getElementsByTagName('body')[0].getAttribute('data-additionnal-categ') : '';
        let coordinatesData = [];
        actMapData.forEach(function(e){
            /*
                En gros a chaque update de la map (on resize ou recherche text/categ) on repasse la fonction qui fait les pins.
                On commence par un add = true, et on passe au travers des possibilités qui pourraient demander leur retrait.
            */
            let addThisElement = true;
            // Check les catégories
            if(categSelects){
                let hasValue = false;
                Array.prototype.forEach.call(categSelects,function(el){
                    // Petite optimisation. Si addThisElement est déja false,
                    // ce qui veut dire ne sera pas redraw,
                    // skipper le check.
                    if(el.value.length > 0 && addThisElement){
                        //console.log(el.value.length);
                        hasValue = true;
                        let needRemoval = true;
                        let hits = 0;
                        let hitlvl1 = 0;
                        let openlvl2 = 0;
                        Array.prototype.forEach.call(el.value,function(categ){
                            //console.log(e.categslugs + ' ' + categ);
                            if(categSearchType == 'AND'){
                                if(e.categslugs){
                                    if(e.categslugs.includes(categ)){
                                        hits++;
                                    }
                                }
                            }if(categSearchType == 'levelbased'){
                                if(e.categslugs){
                                    let el = document.querySelector('[data-categ="'+categ+'"]');
                                    if(el){
                                        if(el.parentElement.classList.contains('side-panel__categ_2')){openlvl2++;}
                                    }
                                    if(e.categslugs.includes(categ)){
                                        if(el){
                                            if(el.parentElement.classList.contains('side-panel__categ_2')){
                                                hits++;
                                            }
                                            if(el.parentElement.classList.contains('side-panel__categ_1')){
                                                hitlvl1++;
                                            }
                                        }
                                    }
                                }
                            }else{
                                if(e.categslugs){
                                    if(e.categslugs.includes(categ)){
                                        needRemoval = false;
                                    }
                                }
                            }
                        });
                        //console.log(e);

                        if(categSearchType == 'AND'){
                            if(hits != el.value.length){
                                addThisElement = false;
                            }
                        }if(categSearchType == 'levelbased'){
                            let removal = true;
                            if(openlvl2 == 0 && hitlvl1 != 0){
                                removal = false;
                            }
                            if(hits != 0){
                                removal = false;
                            }
                            if(removal){
                                addThisElement = false;
                            }
                        }else{
                            if(needRemoval){
                                addThisElement = false;
                            }
                        }
                    };
                })
                //console.log('categ selects')
                //console.log(categSelects)
                if(e.showonlywhenselected && !hasValue){
                    addThisElement = false;
                }
            }else{
                //console.log(e.title +' --- '+e.showonlywhenselected);
            }
            //Check les catégories additionnelles

            if(additionnalCateg && addThisElement){
                if(!e.categslugs.includes(additionnalCateg)){
                    addThisElement = false;
                }
            }

            // Check la recherche textuelle.
            let searchText = '';
            if(searchInput[0]){
                if(searchInput[0].value && addThisElement){
                    searchText = searchInput[0].value
                    //console.log('---')
                    if(e.categ){
                        //console.log(e.categ);
                        if(!e.title.toLowerCase().includes(searchText.toLowerCase()) && !e.categ.toLowerCase().includes(searchText.toLowerCase()) ){
                            //console.log(e.title + ' --- ' + e.categ + ' --- ' + searchInput[0].value + ' --- ' + 'skipped');
                            addThisElement = false;
                        }else{
                            //console.log(e.title + ' --- ' + e.categ + ' --- ' + searchInput[0].value + ' --- ' + 'kept');
                        }
                    }else{
                        //console.log('')
                        if(!e.title.toLowerCase().includes(searchText.toLowerCase()) ){
                            //console.log(e.title + ' --- ' + e.categ + ' --- ' + searchInput[0].value + ' --- ' + 'skipped');
                            addThisElement = false;
                        }else{
                            //console.log(e.title + ' --- ' + e.categ + ' --- ' + searchInput[0].value + ' --- ' + 'kept');
                        }
                    }
                }
            }
            //Si Mode Isolation
            if(mapElement[0].getAttribute('isolated-element') && mapElement[0].getAttribute('isolated-element') != e.id){
                addThisElement = false;
            }
            //console.log('tried '+e.id+'|')
            if(currentOpenPin){
                //console.log(currentOpenPin.alias);
                //console.log('tried '+e.id+'|')

                if(currentOpenPin.alias && currentOpenPin.alias.includes(e.id+'|')){
                    //console.log('added '+e.id)
                    addThisElement = true;
                }
            }
            //console.log('RedoMarks')

            //CARTE SIDEBAR
            /*if (!e.venueCard) {
                e.venueCard = document.getElementById('venue-card-'+e.id);r
            }
            if(e.venueCard){*/
            let card = document.querySelectorAll('.map-venue-card[data-id="'+e.id+'"]');
            if(card.length != 0){
                let hasResults = false;
                card.forEach(function(e2){
                    if(e2.classList.contains('map-venue-card__is-active')){
                        addThisElement = true;
                    }
                    if(addThisElement){
                        e2.classList.remove('map-venue-card__hidden');
                        let title = e2.getElementsByClassName('map-venue-card__name');
                        if (searchText) {
                            let re = new RegExp(`()(${searchText})()`,'ig');
                            let badges = e2.getElementsByClassName('map-badge');
                            Array.prototype.forEach.call(badges,function(b){
                                b.innerHTML = b.getAttribute('data-badge-text').replace(re, `$1<strong>$2</strong>$3`);
                            })
                            title[0].innerHTML = e2.getAttribute('data-title').replace(re, `$1<strong>$2</strong>$3`);
                        }
                        hasResults = true;
                    }else{
                        e2.classList.add('map-venue-card__hidden');
                    }
                    if(e.hiddeninsidebar === true){
                        e2.classList.add('map-venue-card__hidden');
                    }
                })
                checkIfNoResults();
            }
            // FIN CARTE SIDEBAR
            //if(e.type == 'pin' || !e.type){
            if(e.lng && e.lat){
                // Pour PIN START
                //console.log(e.id + ' - ' + e.title + ' - ' + 'Pin');
                //console.log(e);
                //console.log('redraw');
                // if(!e.marker || (drawCategOnPin && mapElement[0].getAttribute('currentcateg-img') == mapElement[0].getAttribute('currentcateg-drawnimg'))){
                if(!e.marker){
                    // if(e.marker){
                    //     e.marker.setMap(null);
                    //     e.marker = null;
                    // }
                    // if(e.htmlMarker){
                    //     e.htmlMarker.setMap(null);
                    //     e.htmlMarker = null;
                    // }
                    const pincolor = e.pincolor ? e.pincolor : "#000";
                    //var pinpath = e.pinpath ? e.pinpath : "M34.1422 33.5876L34.1339 33.5957L21.4026 46.1202C20.6243 46.8859 19.3757 46.8859 18.5974 46.1202L5.86615 33.5957L5.85784 33.5876C-1.95261 25.904 -1.95261 13.4463 5.85784 5.76273C13.6684 -1.92091 26.3316 -1.92091 34.1422 5.76273C41.9526 13.4463 41.9526 25.904 34.1422 33.5876ZM23.5357 16.197C25.4883 18.118 25.4883 21.2323 23.5357 23.1533C21.583 25.0742 18.4172 25.0742 16.4646 23.1533C14.512 21.2323 14.512 18.118 16.4646 16.197C18.4172 14.2761 21.583 14.2761 23.5357 16.197Z"

                    const pinwidth = e.pinwidth ? e.pinwidth : 45;
                    const pinheight = e.pinheight ? e.pinheight : 45;
                    const pinanchorx = e.pinanchorx ? e.pinanchorx : 22;
                    const pinanchory = e.pinanchory ? e.pinanchory : 45;

                    let marker = null;
                    let htmlMarker = null;
                    let zIndex = e.zIndex ? parseInt(e.zIndex)*10 : 0;
                    if (false && markerMode == 'advanced') {
                        /**
                         * new beta version marker,
                         * https://developers.google.com/maps/documentation/javascript/advanced-markers/start
                        marker = new google.maps.marker.AdvancedMarkerView({
                            map,
                            content: buildMarkerMarkup(e),
                            position: { lat: e.lat, lng: e.lng},
                            title: e.title,
                        });
                        */

                    } else {
                        coordinatesData.push({ lat: parseFloat(e.lat), lng: parseFloat(e.lng)});
                        marker = new google.maps.Marker({
                            position:{ lat: parseFloat(e.lat), lng: parseFloat(e.lng)},
                            title:e.title,
                            icon: {
                                url: `data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==`,
                                //path:pinpath,
                                scaledSize: new google.maps.Size(pinwidth, pinheight),
                                anchor: new google.maps.Point(pinanchorx,pinanchory),
                            },
                            id:e.id,
                            optimized: false,
                            canbeclicked: e.canbeclicked ? e.canbeclicked : true,
                            zIndex: (mapElement[0].getAttribute('data-open-pin') && mapElement[0].getAttribute('data-open-pin') == e.id) ? 9999+zIndex : 999+zIndex,
                        });
                        //console.log(e.icon);
                        let ElementIcon = e.icon;
                        if(!ElementIcon){
                            ElementIcon = iconDefault;
                        }
                        if(mapElement[0].getAttribute('currentcateg-img') && mapElement[0].getAttribute('currentcateg-img') != ''){
                            ElementIcon = '<img src="'+mapElement[0].getAttribute('currentcateg-img')+'" loading="lazy" />';
                        }
                        htmlMarker = new HtmlMarker({ lat: parseFloat(e.lat), lng: parseFloat(e.lng)}, ElementIcon, e.title, e.color);
                        //console.log(ElementIcon);
                        e.htmlMarker = htmlMarker;
                        //htmlMarker.setMap(map);
                        //Add custom overlay
                    }
                    if(marker.infowindow !== false){
                        const infowindowContent = generateInfoWindowContent(e);
                        marker.addListener('focus',()=>{
                            closeInfoWindow();
                            infowindow.setContent(infowindowContent);
                            infowindow.open({
                                anchor:marker,
                                //position:{ lat: parseFloat(e.lat), lng: parseFloat(e.lng)},
                                map,
                                //shouldFocus: true,
                            });
                            infowindow.setPosition(new google.maps.LatLng(e.lat,e.lng));
                        })
                        marker.addListener('mouseover',()=>{
                            if (infowindow.getContent().indexOf('infowindow--active') < 0) {
                                closeInfoWindow();
                                infowindow.setContent(infowindowContent);
                                infowindow.open({
                                    anchor:marker,
                                    //position:{ lat: parseFloat(e.lat), lng: parseFloat(e.lng)},
                                    map,
                                    //shouldFocus: true,
                                });
                                infowindow.setPosition(new google.maps.LatLng(e.lat,e.lng));
                            }
                        });
                        marker.addListener('mouseout',()=>{
                            if (infowindow.getContent().indexOf('infowindow--active') < 0) {
                                infowindowTimeout = setTimeout(closeInfoWindow, 250);
                            }
                        })
                    }
                    //console.log(e);
                    if(e.canbeclicked === false){

                    }else{
                        marker.addListener('click',()=>{
                            openPin(e.id, true)
                        })
                    }
                    /*marker.addListener('blur',()=>{
                        infowindow.close();
                    })*/
                    //bounds.extend({ lat: parseFloat(e.lat), lng: parseFloat(e.lng)});
                    //clusters.addMarker(marker, true);
                    e.marker = marker;
                }
                if (addThisElement){
                    fitBounds = true;
                    //e.marker.setMap(map);
                    clusters.addMarker(e.marker, true);
                    if(checkWithinBounds(e.lat,e.lng)){
                        bounds.extend({ lat: parseFloat(e.lat), lng: parseFloat(e.lng)});
                    }
                }else{
                    //e.marker.setMap(null);
                }
                // Pin FIN
            }

            if(drawCategOnPin && e.htmlMarker && mapElement[0].getAttribute('currentcateg-img') != mapElement[0].getAttribute('currentcateg-drawnimg')){
                let newIcon;
                if (!mapElement[0].getAttribute('currentcateg-img')) {
                    newIcon = e.icon;
                    if(!newIcon){
                        newIcon = iconDefault;
                    }
                } else {
                    newIcon = '<img src="'+mapElement[0].getAttribute('currentcateg-img')+'" loading="lazy" />';
                }
                e.htmlMarker.icon = newIcon;
                setIconInHtmlMarker(newIcon, e.htmlMarker);
            }
            //if(e.type == 'geojson'){
            if(e.geojson){
                //GEO START
                //console.log(e.id + ' - ' + e.title + ' - ' + 'Geo');
                let marker = null;
                let marker_label = null;
                let parsedJson = JSON.parse(e.geojson);
                let styleObject = {};
                let zIndex = e.zIndex ? parseInt(e.zIndex)*10 : 0;
                //console.log(e.geojsonStrokeColor);
                //console.log(parsedJson.features[0].properties);
                if(e.geojsonFillColor){styleObject.fillColor = e.geojsonFillColor;}else if(parsedJson.features[0].properties.fill){ styleObject.fillColor = parsedJson.features[0].properties.fill; }
                if(e.geojsonFillOpacity){styleObject.fillOpacity = e.geojsonFillOpacity;}else if(parsedJson.features[0].properties['fill-opacity']){ styleObject.fillOpacity = parsedJson.features[0].properties['fill-opacity']; }
                if(e.geojsonStrokeWidth){styleObject.strokeWeight = e.geojsonStrokeWidth;}else if(parsedJson.features[0].properties['stroke-width']){ styleObject.strokeWeight = parsedJson.features[0].properties['stroke-width']; }
                if(e.geojsonStrokeOpacity){styleObject.strokeOpacity = e.geojsonStrokeOpacity;}else if(parsedJson.features[0].properties['stroke-opacity']){ styleObject.strokeOpacity = parsedJson.features[0].properties['stroke-opacity']; }
                if(e.geojsonStrokeColor){styleObject.strokeColor = e.geojsonStrokeColor;}else if(parsedJson.features[0].properties.stroke){ styleObject.strokeColor = parsedJson.features[0].properties.stroke; }
                styleObject.zIndex = (mapElement[0].getAttribute('data-open-pin') && mapElement[0].getAttribute('data-open-pin') == e.id) ? 9999+zIndex : 999+zIndex;
                //console.log(styleObject);
                if(!e.zone){
                    try{
                        marker = new google.maps.Data({
                            map: map,
                            zIndex: (mapElement[0].getAttribute('data-open-pin') && mapElement[0].getAttribute('data-open-pin') == e.id) ? 9999+zIndex : 999+zIndex,
                        });
                        let st = require('geojson-bounds');
                        let zoneBounds = new google.maps.LatLngBounds();
                        if(e.shape_label){
                            var markerLabelSVG = '<svg xmlns="http://www.w3.org/2000/svg"><text x="0" y="12" class="svgpathpin" style="'+geoJsonLabelStyles+'">'+e.shape_label+'</text></svg>';
                            var adjustX = parseFloat(e.shape_label_x) ? parseFloat(e.shape_label_x) : 0 ;
                            var adjustY = parseFloat(e.shape_label_y) ? parseFloat(e.shape_label_y) : 0 ;
                            /*console.log(e.shape_label);
                            console.log(adjustX);
                            console.log(adjustY);*/
                            marker_label=new google.maps.Marker({
                                position: new google.maps.LatLng((st.yMin(parsedJson)+st.yMax(parsedJson))/2+parseFloat(adjustY), (st.xMin(parsedJson)+st.xMax(parsedJson))/2+parseFloat(adjustX)),
                                map: map,
                                title: '',
                                icon: { url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(markerLabelSVG), scaledSize: new google.maps.Size(20, 20) },
                                optimized: false,
                                zIndex: (mapElement[0].getAttribute('data-open-pin') && mapElement[0].getAttribute('data-open-pin') == e.id) ? 9999+zIndex : 999+zIndex,
                            });
                            //console.log('label')
                        }
                        marker.addGeoJson(parsedJson);
                        if(styleObject){
                            marker.setStyle(styleObject);
                        }
                    }catch(error){
                        console.log(e.id + ' - ' + e.title + ' - ' + 'GeoJSON Invalid')
                        console.log(error);
                    }
                    e.zone = marker;
                    e.marker_label = marker_label;
                    let st = require('geojson-bounds');
                    let zoneBounds = new google.maps.LatLngBounds();
                    zoneBounds.extend({ lat: st.yMin(parsedJson), lng: st.xMin(parsedJson)});
                    zoneBounds.extend({ lat: st.yMax(parsedJson), lng: st.xMax(parsedJson)});
                    e.zoneBounds = zoneBounds;
                    //console.log(e);
                    if(e.canbeclicked === false){

                    }else{
                        marker.addListener('click',()=>{
                            openPin(e.id, true)
                        })
                    }
                    map.data.add(marker);
                    if(marker_label){
                        map.data.add(marker_label);
                    }
                }else{
                    marker = e.zone;
                    marker_label = e.marker_label;
                }
                if (addThisElement){
                    //console.log(marker);
                    fitBounds = true;
                    let st = require('geojson-bounds');
                    if(st){
                        if(checkWithinBounds(st.yMin(parsedJson),st.xMin(parsedJson))){
                            bounds.extend({ lat: st.yMin(parsedJson), lng: st.xMin(parsedJson)});
                        }
                        if(checkWithinBounds(st.yMax(parsedJson),st.xMax(parsedJson))){
                            bounds.extend({ lat: st.yMax(parsedJson), lng: st.xMax(parsedJson)});
                        }
                    }
                    marker.setMap(map);
                    if(marker_label){
                        marker_label.setMap(map);
                    }
                }else{
                    //map.data.remove(marker);
                    marker.setMap(null);
                    if(marker_label){
                        marker_label.setMap(null);
                    }
                }
                //GEO END
            }/*else{
                console.log(e.id + ' - ' + e.title + ' - ' + 'Type non supporté');
            }*/
        });
        if(enableLines) {
            const flightPath = new google.maps.Polyline({
                path: coordinatesData,
                geodesic: true,
                strokeColor: "#168080",
                strokeOpacity: 1.0,
                strokeWeight: 3,
            });

            flightPath.setMap(map);
        }

        if (highlightZone) {
            highlightZone.setMap(null);
            highlightZone = null;
        }
        // console.log('valeur de highlightZone : ',highlightZone);
        if (!highlightZone) {
            const polygon = new google.maps.Polygon(highlightPolygonConfig);
            polygon.setMap(map);
            highlightZone = polygon;
        }

        clusters.render();
    };
    //Geolocate
    let glat = 0;
    let glng = 0;
    //console.log('Geolocate Try')
    const customGeolocArray = customGeoloc.split(',');
    if (activeGeolocalisation && navigator.geolocation) {
        fitBounds = true;

        navigator.geolocation.getCurrentPosition(position => {
            glat = position.coords.latitude;
            glng = position.coords.longitude;
            let geolocateIconSvgCode = window.btoa(geolocateIconSvg);
            let marker = new google.maps.Marker({
                position:{ lat: glat, lng: glng},
                lat:glat,
                lng:glng,
                icon: {
                    url: `data:image/svg+xml;base64,${geolocateIconSvgCode}`,
                    //path:pinpath,
                    scaledSize: new google.maps.Size(geolocateIconWidth, geolocateIconHeight),
                    anchor: new google.maps.Point(geolocateAnchorX,geolocateAnchorY),
                },
                map: map,
                id:'geolocate-pin',
                optimized: false
            });
            bounds.extend({ lat: glat, lng: glng});
            marker.setMap(map);
            map.fitBounds(bounds,0);
        });
    }else if(customGeolocArray.length == 2){
        fitBounds = true;

        //navigator.geolocation.getCurrentPosition(position => {
            glat = parseFloat(customGeolocArray[0]);
            glng = parseFloat(customGeolocArray[1]);
            let geolocateIconSvgCode = window.btoa(geolocateIconSvg);
            let marker = new google.maps.Marker({
                position:{ lat: glat, lng: glng},
                lat:glat,
                lng:glng,
                icon: {
                    url: `data:image/svg+xml;base64,${geolocateIconSvgCode}`,
                    //path:pinpath,
                    scaledSize: new google.maps.Size(geolocateIconWidth, geolocateIconHeight),
                    anchor: new google.maps.Point(geolocateAnchorX,geolocateAnchorY),
                },
                map: map,
                id:'geolocate-pin',
                optimized: false
            });
            bounds.extend({ lat: glat, lng: glng});
            marker.setMap(map);
            map.fitBounds(bounds,0);
            //});
        }
        //console.log(fitBounds);
        //console.log(closePins);
        //Avait aussi ClosePins, je sais pas trop pourquoi. Si on veut fermer les pins présentes sa ne devrait pas avoir un impact sur si oui ou non on fit bounds
        if (fitBounds && closePins) {
            google.maps.event.addListenerOnce(map, "bounds_changed", function () {
                this.setZoom(Math.min(this.getZoom(), zoomOnOpen));
            });
            map.fitBounds(bounds,0);
        }
    mapElement[0].setAttribute('currentcateg-drawnimg',mapElement[0].getAttribute('currentcateg-img'));
}

const searchClear = document.getElementsByClassName('js-clear-search');
if(searchClear[0]){
    searchClear[0].addEventListener('click',clearTextualSearch)
}

function clearTextualSearch(e){
    e.preventDefault();
    if(searchInput[0]){
        searchInput[0].value = '';
        searchInput[0].parentElement.classList.remove('map-text-search__has-data');
    }
    if(!document.querySelectorAll('.side-panel__toggle-results--active').length) {
        $side_panel.classList.remove('side-panel--fully-opened');
    }
    redoMarkers();
    triggerRedoMarkersByTextSearch();
    return false;
}

Array.prototype.forEach.call(mapVenueCards,function(el){
    //console.log(el);
    el.addEventListener('click',function(){
        openPin(el.getAttribute('data-id'));
    })
})

function findIndex(via,value){
    let toReturn = "";
    actMapData.forEach(function(e){
        if(e[via] == value){
            toReturn = e;
        }
    })
    return toReturn;
}

function openPin(id=0, animated=true){
    closeInfoWindow();
    if($dataPanel != null){
        $dataPanel.destroy();
    }
    console.log('OPEN PIN: '.id);
    const elementToOpen = findIndex('id',id);
    const dataPanel = document.getElementsByClassName('js-close-data-panel');

    //console.log(mapElement[0].getAttribute('data-open-pin'));
    if(!mapElement[0].getAttribute('data-open-pin')){
        //console.log('set')
        window.localStorage.setItem('gmap-center',map.getCenter());
        window.localStorage.setItem('gmap-zoom',map.getZoom());
    }else{
        //console.log('dont set')
    }

    mapElement[0].setAttribute('data-open-pin',id);
    if($side_panel){
        $side_panel.classList.add('has-open-pin');
    }

    //const dataPanel = document.getElementsByClassName('data-panel');
    if(dataPanel.length != 0){
        dataPanel[0].focus();
        dataPanel[0].blur();
    }


    const infowindowContent = generateInfoWindowContent(elementToOpen);

    if (map.getZoom() < zoomOnOpen) {
        map.setZoom(zoomOnOpen);
    }
    if(elementToOpen.lat && elementToOpen.lng){
        if (animated) {
            map.panTo(new google.maps.LatLng(elementToOpen.lat,elementToOpen.lng));
        } else {
            map.setCenter(new google.maps.LatLng(elementToOpen.lat,elementToOpen.lng));
        }
    }
    closeInfoWindow();
    // console.log(elementToOpen.infowindow);
    if(elementToOpen.infowindow !== false && elementToOpen.keepInfowindowClosedOnPinOpen != 1){
        // console.log("open the window");
        infowindow.setContent(infowindowContent.replace('"infowindow"', '"infowindow infowindow--active"'));
        // console.log('elementToOpen ===',elementToOpen);
        // console.log('map ===',map);
        infowindow.open({
            anchor:elementToOpen.marker,
            map,
            //shouldFocus: true,
        });
        infowindow.setPosition(new google.maps.LatLng(elementToOpen.lat,elementToOpen.lng));
        // console.log("after open the window");
    }
    //console.log(elementToOpen);
    const $panel = document.querySelector('.carte-layout__data-panel');
    if($panel){
        $panel.classList.remove('carte-layout__data-panel--hidden');
    }

    let $sliderHtml = '';
    //console.log(elementToOpen.images);
    if(elementToOpen.images){
        Array.prototype.forEach.call(elementToOpen.images,function(el){
            //console.log(el);
            let styles = '';
            if(elementToOpen.imagealign){
                styles = 'object-position:'+elementToOpen.imagealign+';'
            }
            $sliderHtml += '<img src="'+el+'" loading="lazy" alt="'+elementToOpen.title+'" style="'+styles+'" /> ';
        })
    }
    document.querySelector('.data-panel__slider').innerHTML = $sliderHtml;

    let $badgesHtml = '';
    if(elementToOpen.categ){
        elementToOpen.categ.split('|').forEach((el)=>{
            //console.log(el);
            if(!el){

            }else if(el.includes('~')){
                el = el.split('~')
                $badgesHtml += '<div class="map-badge" style="--added-color:'+el[0]+';--contrasted-color:'+getContrastYIQ(el[0])+'">'+el[1]+'</div>';
            }else{
                $badgesHtml += '<div class="map-badge">'+el+'</div>';
            }
        })
        if(document.querySelector('.data-panel__badges')){
            document.querySelector('.data-panel__badges').innerHTML = $badgesHtml;
        }
    }else{
        document.querySelector('.data-panel__badges').innerHTML = "";
    }

    const $defaultFill = document.getElementsByClassName('js-default-fill');
    Array.prototype.forEach.call($defaultFill,function(el){
        //console.log(elementToOpen[el.getAttribute("data-filltype")]);
        if(elementToOpen[el.getAttribute("data-filltype")]){
            el.innerHTML = elementToOpen[el.getAttribute("data-filltype")];
            el.parentElement.setAttribute('style','');
        }else{
            el.parentElement.setAttribute('style','display:none;');
        }
    })

    const $emailFill = document.getElementsByClassName('js-email-fill');
    Array.prototype.forEach.call($emailFill,function(el){
        //console.log(elementToOpen[el.getAttribute("data-filltype")]);
        if(elementToOpen[el.getAttribute("data-filltype")]){
            el.innerHTML = elementToOpen[el.getAttribute("data-filltype")];
            el.setAttribute('href','mailto:'+elementToOpen[el.getAttribute("data-filltype")])
            el.parentElement.setAttribute('style','');
        }else{
            el.parentElement.setAttribute('style','display:none;');
        }
    })

    const $planDetourFill = document.getElementsByClassName('js-plan-detour-fill');
    Array.prototype.forEach.call($planDetourFill,function(el){
        if(elementToOpen[el.getAttribute("data-filltype")]){
            el.setAttribute('href', elementToOpen[el.getAttribute("data-filltype")]);
            el.parentElement.parentElement.setAttribute('style','');
        }else{
            el.parentElement.parentElement.setAttribute('style','display:none;');
        }
    })

    if(document.querySelector('.data-panel__know-more')){
        if(elementToOpen.link == '' || elementToOpen.link == 'null' || !elementToOpen.link){
            document.querySelector('.data-panel__know-more').setAttribute('style','display:none;');
        }else{
            document.querySelector('.data-panel__know-more').setAttribute('href',elementToOpen.link);
            document.querySelector('.data-panel__know-more').setAttribute('style','');
        }
    }
    if(document.querySelector('.data-panel__gmaps')){
        if(elementToOpen.lat &&elementToOpen.lng){
            document.querySelector('.data-panel__gmaps').setAttribute('href',"https://www.google.com/maps/search/"+elementToOpen.title+"/@"+elementToOpen.lat+","+elementToOpen.lng+",15z");
            document.querySelector('.data-panel__gmaps').setAttribute('style','');
        }else{
            document.querySelector('.data-panel__gmaps').setAttribute('style','display:none;');
        }
    }

    $dataPanel = tns({
        //mode: 'gallery',
        //animateIn: 'fadeInDown',
        //animateOut: 'fadeOutDown',
        animateDelay: 750,
        autoplayTimeout: 6000,
        controls: true,
        container: '.data-panel__slider',
        autoplay: true,
        //autoplayButton: false,
        nav: true,
    })

    if(elementToOpen.zoneBounds){
        map.fitBounds(elementToOpen.zoneBounds,0);
    }

    Array.prototype.forEach.call(mapVenueCards,function(e){
        e.classList.remove('map-venue-card__is-active');
        if(e.getAttribute('data-id') == id){
            e.classList.add('map-venue-card__is-active');
        }
    })
    if(elementToOpen.isolateonopen && elementToOpen.isolateonopen == 1){
        mapElement[0].setAttribute('isolated-element',elementToOpen.id)
        if(sidePanelOfCategs[0]){
            sidePanelOfCategs[0].classList.add('isolation-mode');
        }
    }else{
        if(sidePanelOfCategs[0]){
            sidePanelOfCategs[0].classList.remove('isolation-mode');
        }
    }
    if(elementToOpen.htmlMarker){
        //console.log('addedHTMLMarker')
        elementToOpen.htmlMarker.setMap(map)
    }else if(elementToOpen.marker){
        //console.log('addedMarker')
        elementToOpen.marker.setMap(map)
    }else{
        //console.log('No Markers');
        //console.log(elementToOpen);
    }
    redoMarkers(false);
}

if(document.querySelector('.js-close-data-panel')){
    document.querySelector('.js-close-data-panel').addEventListener('click',closePin);
}

function closePin(resetPosition){
    if (resetPosition !== false) {
        resetPosition = true;
    }
    mapElement[0].setAttribute('isolated-element','')
    //mapElement[0].focus();
    //mapElement[0].blur();
    closeInfoWindow();
    const $panel = document.querySelector('.carte-layout__data-panel');
    /*if($panel && $panel.classList.contains('carte-layout__data-panel--hidden')){
        //already closed
        return;
    } else if ($panel) {
        $panel.classList.add('carte-layout__data-panel--hidden');
    }*/
    $panel.classList.add('carte-layout__data-panel--hidden');
    mapElement[0].setAttribute('data-open-pin','');
    if($side_panel){
        $side_panel.classList.remove('has-open-pin');
    }
    // Attendre que l'anim fermeture soit finie pour ensuite réajuster la map.
    //console.log('hey')
    if (resetPosition) {
        if(window.localStorage.getItem('gmap-zoom')){
            //console.log(window.localStorage.getItem('gmap-zoom'));
            map.setZoom(parseFloat(window.localStorage.getItem('gmap-zoom')));
        }
        if(window.localStorage.getItem('gmap-center')){
            let center = window.localStorage.getItem('gmap-center').replace('(','').replace(')','').replace(' ','').split(',');
            //console.log(center)
            map.panTo(new google.maps.LatLng(center[0],center[1]));
        }
    }
    /*window.setTimeout(function(){
        map.fitBounds(bounds);
    },300)*/
    Array.prototype.forEach.call(mapVenueCards,function(e){
        e.classList.remove('map-venue-card__is-active')
    })
    redoMarkers(false);
}

const categSelectors = document.getElementsByClassName('js-select-category');
if(categSelectors){
    Array.prototype.forEach.call(categSelectors,function(el){
        el.addEventListener('click',function(e){
            e.preventDefault();
            let categ = el.getAttribute('data-categ');
            let addingElement = false;
            let optionIsInSelects = false;
            //Si on trouve la catégorie dans les selects du header
            const selects = document.getElementsByClassName('map-category-select');
            Array.prototype.forEach.call(selects,function(el){
                Array.prototype.forEach.call(el.options,function(option){
                    //Essai de trouver la catégorie parmis les selects
                    if(option.value == categ){
                        //console.log(el.value);
                        let ogValue = el.value;
                        if(el.value.includes(categ)){
                            ogValue.splice(ogValue.indexOf(categ));
                            addingElement = false;
                        }else{
                            ogValue.push(categ)
                            addingElement = true;
                        }
                        el.setValue(ogValue);
                        optionIsInSelects = true;
                    }
                })
            })
            if(!optionIsInSelects){
                //Set/unset de la catégorie si elle n'est pas dans les selects
                if(document.getElementsByTagName('body')[0].getAttribute('data-additionnal-categ') == categ){
                    document.getElementsByTagName('body')[0].setAttribute('data-additionnal-categ','');
                    addingElement = false;
                }else{
                    document.getElementsByTagName('body')[0].setAttribute('data-additionnal-categ',categ);
                    addingElement = true;
                }
            }
            if(addingElement){
                mapElement[0].setAttribute('currentCateg', categ);
                let icon = el.querySelector('.icon img');
                //console.log(icon);
                if(icon){
                    mapElement[0].setAttribute('currentCateg-img', icon.getAttribute('src'));
                }
            }else{
                mapElement[0].removeAttribute('currentCateg');
                mapElement[0].removeAttribute('currentCateg-img');
            }
            redoMarkers();
            return false;
        })
    });
}

window.addEventListener('keydown',checkForEscape);

function checkForEscape(e){
    //console.log(e.keyCode);
    if(e.keyCode == 27){
        closePin();
    }
}

function checkIfNoResults(){
    let hasResults = false;
    Array.prototype.forEach.call(mapVenueCards,function(e){
        if(!e.classList.contains('map-venue-card__hidden')){
            hasResults = true;
        }
    })
    if(noResultsText[0]){
        if(hasResults){
            noResultsText[0].classList.remove('side-panel__has-no-results')
        }else{
            noResultsText[0].classList.add('side-panel__has-no-results')
        }
    }
}

function checkWithinBounds(lng,lat){
    if(boundsboxArray.length != 1 && boundsboxArray.length != 4){
        console.log('Mauvaise configuration du box bounds. Besoin de 4 valeurs, séparées par virgules (Nord,Sud,Est,Ouest). Le floating point doit être un point.')
    }
    if(boundsboxArray.length != 4){
        return true;
    }
    const maxLat = Math.max.apply(Math,[parseFloat(boundsboxArray[0]),parseFloat(boundsboxArray[1])]);
    const minLat = Math.min.apply(Math,[parseFloat(boundsboxArray[0]),parseFloat(boundsboxArray[1])]);
    const maxLng = Math.max.apply(Math,[parseFloat(boundsboxArray[2]),parseFloat(boundsboxArray[3])]);
    const minLng = Math.min.apply(Math,[parseFloat(boundsboxArray[2]),parseFloat(boundsboxArray[3])]);
    if(urlParams.get('boundsboxdebug') == 1){
        const rectangle = new google.maps.Rectangle({
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#FF0000",
        fillOpacity: 0.35,
        map,
        bounds: {
            north: minLng,
            south: maxLng,
            east: maxLat,
            west: minLat,
        },
        });
        rectangle.setMap(map);
    }
    //console.log(map)
    return maxLat > lat && minLat < lat && maxLng > lng && minLng < lng;
}

function getContrastYIQ(hexcolor){
    var r = parseInt(hexcolor.substring(1,3),16);
    var g = parseInt(hexcolor.substring(3,5),16);
    var b = parseInt(hexcolor.substring(5,7),16);
    var yiq = ((r*299)+(g*587)+(b*114))/1000;
    return (yiq >= 128) ? 'black' : 'white';
}
